import { c as _c } from "react/compiler-runtime";
import { FlexCenter } from "@opensea/ui-kit";
import { SocialLinks } from "@/components/social/SocialLinks";
import { DISCORD_URL, INSTAGRAM_USERNAME, TELEGRAM_USERNAME, X_USERNAME } from "@/constants/constants";
export function PageFooterSocialLinks() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FlexCenter className="gap-3" color="text-secondary"><SocialLinks.Discord href={DISCORD_URL} size={16} /><SocialLinks.Telegram size={16} username={TELEGRAM_USERNAME} /><SocialLinks.Twitter size={16} username={X_USERNAME} /><SocialLinks.Instagram size={16} username={INSTAGRAM_USERNAME} /></FlexCenter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}